<template>
    <div class="no-content">
        <div class="no-content__content">
           <slot>
               <h2>No Data</h2>
               <div>We currently don’t have any data on this request at the moment. <br />
                   Please check back later.</div>
           </slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NotFound',
}
</script>
<style lang="scss" scoped>
  .no-content {
      font-family: 'Calibre';
      background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 90px 94px;
    display: flex;
    justify-content: center;
    /*margin: 0 30px;*/
      text-align: center;

    &__content {
        display: flex;
        flex-direction: column;
    }

    h1 {
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 29px;
        color: #261940;
        margin-bottom: 13px;
    }

    p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        color: #261940;
        opacity: 0.7;
        padding: 5px 0;
    }

    h4 {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #261940;
        padding-top: 20px;
        padding-bottom: 5px;
    }

    .tab__content__top__item {
        margin-top: 20px;
        margin-left: 0;
    }
  }
</style>